import React from 'react';
import { TouchableOpacity, Text, StyleSheet, ActivityIndicator, View } from 'react-native';
import { useTheme } from '../hooks/useTheme';
import { Colors, Spacing, Radius, FontSize, FontWeight } from '../theme/tokens';
import { Icon, IconName } from './Icon';

interface ButtonProps {
  label:     string;
  onPress:   () => void;
  type?:     'primary' | 'secondary' | 'danger';
  disabled?: boolean;
  loading?:  boolean;
  icon?:     IconName;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  label,
  onPress,
  type = 'primary',
  disabled = false,
  loading = false,
  icon,
  fullWidth = false,
}) => {
  const { colors } = useTheme();

  const bgColor = type === 'primary'   ? colors.brand
                : type === 'danger'    ? colors.text
                : colors.surface;

  const textColor = type === 'secondary' ? colors.text : colors.brandText;
  const iconColor = type === 'secondary' ? colors.text : colors.brandText;

  const borderStyle = type === 'secondary'
    ? { borderWidth: 1, borderColor: colors.border }
    : {};

  return (
    <TouchableOpacity
      style={[
        styles.btn,
        { backgroundColor: bgColor, ...borderStyle },
        fullWidth && styles.fullWidth,
        disabled && styles.disabled,
      ]}
      onPress={onPress}
      disabled={disabled || loading}
      activeOpacity={0.8}
    >
      {loading ? (
        <ActivityIndicator color={iconColor as string} size="small" />
      ) : (
        <View style={styles.row}>
          {icon && <View style={styles.iconGap}><Icon name={icon} size={20} color={iconColor as string} /></View>}
          <Text style={[styles.label, { color: textColor as string }]}>{label}</Text>
        </View>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  btn: {
    borderRadius:    Radius.pill, // 48px pill
    justifyContent:  'center',
    alignItems:      'center',
    paddingVertical: 14,
    paddingHorizontal: 24,
  },
  fullWidth: {
    width: '100%',
  },
  disabled: {
    opacity: 0.4,
  },
  row: {
    flexDirection:  'row',
    alignItems:     'center',
    justifyContent: 'center',
  },
  iconGap: {
    marginRight: Spacing.sm,
  },
  label: {
    fontSize:   FontSize.sm,
    fontWeight: FontWeight.semibold,
  },
});
